export default {
    custom: 0,
    rainbow: 1
}